import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import TopPage from '../views/TopPage.vue';
import SearchCourse from '../views/SearchCourse.vue';
import UpdateHistory from '../views/UpdateHistory.vue';
import TeikiTop from '../views/TeikiTop.vue';
import TeikiList from '../views/TeikiList.vue';
import TeikiResult from '../views/TeikiResult.vue';
import TeikiTerms from '../views/TeikiTerms.vue';
import Constants from '@/constants';

const router = createRouter({
  history: Constants.DEBUG_MODE && Constants.DEBUG_MODE === 'true' ? createWebHashHistory('') : createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'TeikiTop',
      component: Constants.IS_USER_PAGE && Constants.IS_USER_PAGE === 'true' ? TeikiTerms : TeikiTop,
    },
    {
      path: '/teiki',
      name: 'TeikiInput',
      component: TeikiTop,
    },
    {
      path: '/top',
      name: 'TopPage',
      component: TopPage,
    },
    {
      path: '/search',
      name: 'SearchCourse',
      component: SearchCourse,
    },
    {
      path: '/update',
      name: 'UpdateHistory',
      component: UpdateHistory,
    },
    {
      path: '/add',
      name: 'AddTeiki',
      component: TeikiTop,
    },
    {
      path: '/list',
      name: 'TeikiList',
      component: TeikiList,
    },
    {
      path: '/add/list',
      name: 'AddTeikiList',
      component: TeikiList,
    },
    {
      path: '/result',
      name: 'TeikiResult',
      component: TeikiResult,
    },
  ]
});

export default router;
